/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BigNumberish,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  BalancerV2PriceProvider,
  BalancerV2PriceProviderInterface,
} from "../BalancerV2PriceProvider";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "_priceProvidersRepository",
        type: "address",
      },
      {
        internalType: "contract IVault",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "uint32",
        name: "_periodForAvgPrice",
        type: "uint32",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint32",
        name: "period",
        type: "uint32",
      },
    ],
    name: "NewPeriod",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint32",
        name: "ago",
        type: "uint32",
      },
    ],
    name: "NewSecondsAgo",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newPendingOwner",
        type: "address",
      },
    ],
    name: "OwnershipPending",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "poolId",
        type: "bytes32",
      },
    ],
    name: "PoolForAsset",
    type: "event",
  },
  {
    inputs: [],
    name: "acceptOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "assetSupported",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "assetsPools",
    outputs: [
      {
        internalType: "bytes32",
        name: "poolId",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "priceOracle",
        type: "address",
      },
      {
        internalType: "bool",
        name: "token0isAsset",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_period",
        type: "uint32",
      },
    ],
    name: "changePeriodForAvgPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_ago",
        type: "uint32",
      },
    ],
    name: "changeSecondsAgo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_period",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "_ago",
        type: "uint32",
      },
    ],
    name: "changeSettings",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_poolId",
        type: "bytes32",
      },
    ],
    name: "getPoolQuoteLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "periodForAvgPrice",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "priceBufferReady",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProviderPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProvidersRepository",
    outputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quoteToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "removePendingOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_poolId",
        type: "bytes32",
      },
    ],
    name: "resolvePoolAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "secondsAgo",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "_poolId",
        type: "bytes32",
      },
    ],
    name: "setupAsset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newPendingOwner",
        type: "address",
      },
    ],
    name: "transferPendingOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "vault",
    outputs: [
      {
        internalType: "contract IVault",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_poolId",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "verifyPool",
    outputs: [
      {
        internalType: "contract IERC20[]",
        name: "tokens",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type BalancerV2PriceProviderConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: BalancerV2PriceProviderConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class BalancerV2PriceProvider__factory extends ContractFactory {
  constructor(...args: BalancerV2PriceProviderConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "BalancerV2PriceProvider";
  }

  deploy(
    _priceProvidersRepository: string,
    _vault: string,
    _periodForAvgPrice: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<BalancerV2PriceProvider> {
    return super.deploy(
      _priceProvidersRepository,
      _vault,
      _periodForAvgPrice,
      overrides || {}
    ) as Promise<BalancerV2PriceProvider>;
  }
  getDeployTransaction(
    _priceProvidersRepository: string,
    _vault: string,
    _periodForAvgPrice: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _priceProvidersRepository,
      _vault,
      _periodForAvgPrice,
      overrides || {}
    );
  }
  attach(address: string): BalancerV2PriceProvider {
    return super.attach(address) as BalancerV2PriceProvider;
  }
  connect(signer: Signer): BalancerV2PriceProvider__factory {
    return super.connect(signer) as BalancerV2PriceProvider__factory;
  }
  static readonly contractName: "BalancerV2PriceProvider";
  public readonly contractName: "BalancerV2PriceProvider";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BalancerV2PriceProviderInterface {
    return new utils.Interface(_abi) as BalancerV2PriceProviderInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BalancerV2PriceProvider {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as BalancerV2PriceProvider;
  }
}
